import { useEffect, useState } from 'react';
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { Breadcrumbs, Btn } from 'AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourses } from 'Features/Learning/Courses/Utils/CoursesUtils';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import Swal from 'sweetalert2';
import AsyncSelectCommon from 'Component/Learning/Common/SelectOption/AsyncSelect';
import { useNavigate, useParams } from 'react-router';
import { submitGuidelines, fetchGuidelines } from 'Features/Learning/Guidelines/Utils/GuidelineUtils';
import { resetStateGuideline } from 'Features/Learning/Guidelines/addGuidelineSlice';
import { handleCopy } from 'Component/Learning/Membership/GuidelineMembership/GuidelineUtil';
import { getAppHostnamePrefix } from 'Utils/environment';
import ModalTryout from './ModalTryout';

const GuidelineAdd = () => {
  const { membershipId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const filtersCourse = useSelector(state => state.Course.filters);
  const data = useSelector(state => state.addGuideline);
  // Loading state manual untuk disable button dan show loading indicator
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [titleGroup, setTitleGroup] = useState('');
  const [items, setItems] = useState([
    { type: 'ecourse', course: null, material: null, tryout: null, customMaterialName: '', link: '' }
  ]);
  const [dayOptions, setDayOptions] = useState([]);
  const [modalTryout, setModalTryout] = useState(false);
  const [currentItemIndex, setCurrentItemIndex] = useState(null);

  // Load existing days saat component mount
  useEffect(() => {
    dispatch(fetchGuidelines(membershipId)).then((response) => {
      const days = response?.payload?.data?.days || [];
      const options = days.map(d => ({ value: d, label: d }));
      setDayOptions(options);
    });
  }, [dispatch, membershipId]);

  useEffect(() => {
    if (data?.isUpdate && data?.id) {
      setSelectedDay({ value: data.day, label: data.day });
      setTitleGroup(data.title_group);

      const initialItems = data.items.map(item => {
        // Parse link untuk deteksi tipe
        let type = 'ecourse';
        let tryout = null;

        if (item.link?.includes('/classes/tryout/')) {
          type = 'tryout';
          // Extract tryoutId dari URL: /classes/tryout/{tryoutId}/start?membershipId=...
          const match = item.link.match(/\/classes\/tryout\/(\d+)\/start/);
          if (match && match[1]) {
            tryout = {
              value: parseInt(match[1]),
              label: item.title || `Tryout ${match[1]}`
            };
          }
        }

        return {
          type,
          course: item.course ? {
            value: item.course.id,
            label: item.course.title,
            materials: item.course.materials
          } : null,
          material: item.material ? {
            value: item.material.id,
            label: item.material.name
          } : null,
          tryout,
          customMaterialName: item.title || '', // always populate custom input from item.title
          link: item.link || ''
        };
      });

      setItems(initialItems);
    }
  }, [data]);

  const promiseOptions = (inputValue, callback) => {
    dispatch(fetchCourses({
      ...filtersCourse,
      'filter[title]': inputValue,
      'sort': '-id',
    }))
      .then((response) => {
        const options = response.payload.data.map(item => ({
          value: item.id,
          label: item.title,
          materials: item.materials,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
        callback([]);
      });
  };

  const handleSelectChange = (index, selectedOption) => {
    if (selectedOption !== null && selectedOption.materials.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Belum ada materi dalam course ini! Pilih yang lain atau tambahkan materi ke course ini.',
      });
    } else {
      handleCourseChange(index, selectedOption);
    }
  }

  const handleAddItem = () => {
    setItems([...items, { type: 'ecourse', course: null, material: null, tryout: null, customMaterialName: '' }]);
  };

  console.log('items', items);

  const handleRemoveItem = (index) => {
    const updated = [...items];
    updated.splice(index, 1);
    setItems(updated);
  };

  const handleCourseChange = (index, selectedOption) => {
    const updated = [...items];
    updated[index] = {
      ...updated[index],
      course: selectedOption,
      material: null, // reset material ketika course berubah
    };
    setItems(updated);
  };

  const handleMaterialChange = (index, selectedOption) => {
    const updated = [...items];
    updated[index] = {
      ...updated[index],
      material: selectedOption,
    };
    setItems(updated);
  };

  const handleCustomMaterialChange = (index, value) => {
    const updated = [...items];
    updated[index] = {
      ...updated[index],
      customMaterialName: value,
    };
    setItems(updated);
  };

  const handleSuccess = () => {
    setIsLoading(false);
    dispatch(resetStateGuideline());
    navigate(`${process.env.PUBLIC_URL}/membership/membership-guideline/${membershipId}`);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Transform items sebelum kirim
    const transformedItems = items.map((item) => {
      // Tryout link format
      if (item.type === 'tryout' && item.tryout) {
        const title = item.customMaterialName || item.tryout.label;
        const link = `https://${getAppHostnamePrefix()}brofesional.id/classes/tryout/${item.tryout.value}/start?membershipId=${membershipId}`;
        return { title, link };
      }

      // E-Course link format (existing)
      const title = item.customMaterialName || item.material?.label || '';
      const link = item.course && item.material
        ? `https://${getAppHostnamePrefix()}brofesional.id/classes/e-course/${membershipId}/${item.course.value}/${item.material.value}/`
        : item.link || '';
      return { title, link };
    });

    dispatch(submitGuidelines({
      membershipId: membershipId,
      day: selectedDay?.value || '',
      title: titleGroup,
      items: transformedItems,
      isUpdate: data?.isUpdate || false,
      id: data?.id || null,
      successCallback: handleSuccess
    }));
  };

  console.log('data guideline add', data);

  const handleTypeChange = (index, typeValue) => {
    const updated = [...items];
    updated[index] = {
      ...updated[index],
      type: typeValue,
      course: null,
      material: null,
      tryout: null,
    };
    setItems(updated);

    if (typeValue === 'tryout') {
      setCurrentItemIndex(index);
    }
  };

  const handleSelectTryout = (tryout) => {
    if (currentItemIndex !== null) {
      const updated = [...items];
      updated[currentItemIndex] = {
        ...updated[currentItemIndex],
        tryout: { value: tryout.id, label: tryout.title },
      };
      setItems(updated);
      setCurrentItemIndex(null);
    }
  };

  return (
    <>
      <Breadcrumbs parent="Membership" title="Tambah Guideline" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-3">
                    <Label for="day" style={{ fontWeight: 'bold' }}>Day:</Label>
                    <CreatableSelect
                      id="day"
                      placeholder="Pilih atau ketik day baru (contoh: Day 1)"
                      isClearable
                      options={dayOptions}
                      value={selectedDay}
                      onChange={setSelectedDay}
                      formatCreateLabel={(inputValue) => `Buat "${inputValue}"`}
                      noOptionsMessage={() => "Ketik untuk membuat day baru"}
                      isDisabled={isLoading}
                    />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label for="titleGroup" style={{ fontWeight: 'bold' }}>Title Group:</Label>
                    <Input
                      id="titleGroup"
                      type="text"
                      name="titleGroup"
                      placeholder="Contoh: TIU, TWK, TKP"
                      value={titleGroup}
                      onChange={(e) => setTitleGroup(e.target.value)}
                      disabled={isLoading}
                    />
                  </FormGroup>

                  <Label style={{ fontWeight: 'bold' }}>Materi:</Label>
                  {items.map((item, index) => (
                    <FormGroup key={index} className="mb-3 p-3" style={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                      <Row>
                        <Col>
                          <Label style={{ fontWeight: 'bold' }}>
                            Item {index + 1}
                            {index > 0 && (
                              <Btn
                                attrBtn={{
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleRemoveItem(index),
                                  disabled: isLoading
                                }}
                              >
                                <i className="fa fa-close mx-auto text-danger fa-2x"></i>
                              </Btn>
                            )}
                          </Label>

                          <FormGroup className='mb-3'>
                            <Label style={{ fontWeight: 'bold' }}>Tipe Konten:</Label>
                            <div className="m-checkbox-inline">
                              <Label for={`type_ecourse_${index}`}>
                                <Input
                                  className="radio_animated"
                                  id={`type_ecourse_${index}`}
                                  type="radio"
                                  name={`type_${index}`}
                                  checked={item.type === 'ecourse'}
                                  onChange={() => handleTypeChange(index, 'ecourse')}
                                  disabled={isLoading}
                                />
                                E-Course
                              </Label>
                              <Label for={`type_tryout_${index}`}>
                                <Input
                                  className="radio_animated"
                                  id={`type_tryout_${index}`}
                                  type="radio"
                                  name={`type_${index}`}
                                  checked={item.type === 'tryout'}
                                  onChange={() => handleTypeChange(index, 'tryout')}
                                  disabled={isLoading}
                                />
                                Tryout
                              </Label>
                            </div>
                          </FormGroup>

                          {item.type === 'ecourse' && (
                            <>
                              <FormGroup className="mb-2">
                                <AsyncSelectCommon
                                  label={'Pilih Course'}
                                  placeholder={'Silahkan pilih Course...'}
                                  isMulti={false}
                                  promiseOptions={promiseOptions}
                                  handleSelectChange={(selectedOption) => handleSelectChange(index, selectedOption)}
                                  selectedValue={item?.course ? { value: item?.course?.value, label: item?.course?.label } : null}
                                  isDisabled={isLoading}
                                />
                              </FormGroup>

                              {item?.course && item?.course?.materials?.length > 0 && (
                                <FormGroup className="mb-2">
                                  <Label>Pilih Material:</Label>
                                  <Select
                                    placeholder="Pilih material..."
                                    options={item?.course?.materials.map(m => ({ value: m.id, label: m.name }))}
                                    value={item.material}
                                    onChange={(opt) => handleMaterialChange(index, opt)}
                                    isClearable={true}
                                    isDisabled={isLoading}
                                  />
                                </FormGroup>
                              )}
                            </>
                          )}

                          {item.type === 'tryout' && (
                            <FormGroup className="mb-2">
                              {item.tryout ? (
                                <>
                                  <Label>Tryout Dipilih:</Label>
                                  <div className="p-2 border rounded d-flex justify-content-between align-items-center">
                                    <strong>{item.tryout.label}</strong>
                                    <Button color="link" size="sm" disabled={isLoading} onClick={() => { setCurrentItemIndex(index); setModalTryout(true); }}>
                                      Ubah
                                    </Button>
                                  </div>
                                </>
                              ) : (
                                <Button color="primary" disabled={isLoading} onClick={() => { setCurrentItemIndex(index); setModalTryout(true); }}>
                                  Pilih Tryout
                                </Button>
                              )}
                            </FormGroup>
                          )}

                          <FormGroup className="mb-2">
                            <Label>Custom Nama {item.type}:</Label>
                            <Input
                              type="text"
                              placeholder={`Nama ${item.type} custom (opsional)`}
                              value={item.customMaterialName}
                              onChange={(e) => handleCustomMaterialChange(index, e.target.value)}
                              disabled={isLoading}
                            />
                          </FormGroup>

                          {data?.isUpdate && item.link && (
                            <FormGroup className="mb-2">
                              <Btn
                                attrBtn={{
                                  title: 'Copy Link',
                                  color: 'link',
                                  outline: true,
                                  className: 'p-1',
                                  onClick: () => handleCopy(item?.link)
                                }}
                              >
                                <i className="icofont icofont-copy-alt mx-auto fa-lg"></i> Copy Link
                              </Btn>
                            </FormGroup>
                          )}
                        </Col>
                      </Row>
                    </FormGroup>
                  ))}

                  <FormGroup className="mb-3">
                    <Btn
                      attrBtn={{
                        color: 'link',
                        outline: true,
                        className: 'p-1',
                        onClick: handleAddItem,
                        disabled: isLoading
                      }}
                    >
                      <i className="fa fa-plus-circle mx-auto fa-2x" style={{ color: '#3C6F7D' }}></i>
                    </Btn>
                  </FormGroup>

                  <div className="d-flex gap-2">
                    <Button color="primary" type="submit" disabled={isLoading}>
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Menyimpan...
                        </>
                      ) : (
                        'Simpan'
                      )}
                    </Button>
                    <Button color="secondary" type="button" disabled={isLoading} onClick={() => {
                      dispatch(resetStateGuideline());
                      navigate(-1)
                    }}>
                      Batal
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <ModalTryout
        isOpen={modalTryout}
        toggle={() => setModalTryout(false)}
        onSelect={handleSelectTryout}
      />
    </>
  );
};

export default GuidelineAdd;